import React, { useState, useEffect } from "react";
import RFQ from "./RFQ";
import Requirements from "./Requirements";
import "../../../styles/TradeToggle.css"; // Import custom CSS for toggle

const AmtplTrade = () => {
  const [activeTab, setActiveTab] = useState("Requirements");
  const [filterType, setFilterType] = useState("Matched");
  const [userType, setUserType] = useState("Buyer");
  const tabs = ["Requirements", "RFQs"];

  // Different filter tabs based on active main tab
  const getFilterTabs = () => {
    if (activeTab === "RFQs") {
      return [
        "Request for Details",
        "Request for Firm Offers",
        "Request for BAFO",
        "Accepted Offers",
      ];
    }
    return ["Matched", "Unmatched"];
  };

  // Reset filter when switching main tabs
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    if (tab === "RFQs") {
      setFilterType("Request for Details"); // Default for RFQ
      setUserType("Buyer"); // Reset to Buyer when switching to RFQs
    } else {
      setFilterType("Matched"); // Default for Requirements
    }
  };

  useEffect(() => {
    // This effect runs whenever activeTab, filterType, or userType changes
    console.log(
      `Tab changed to: ${activeTab}, Filter: ${filterType}, UserType: ${userType}`
    );
    // You can add any additional logic here when tabs change
  }, [activeTab, filterType, userType]);

  const renderTabContent = () => {
    switch (activeTab) {
      case "Requirements":
        return <Requirements filterType={filterType} />;
      case "RFQs":
        return <RFQ filterType={filterType} userType={userType} />;
      default:
        return <Requirements filterType={filterType} />; // Added return statement
    }
  };

  return (
    <div className="buyer-layout">
      <div className="amtpl-tabs">
        <div className="content3">

          <main className="main-content">
            <div className="main-toogle">
                {activeTab === "RFQs" && (
                  <div className="user-type-toggle-container">
                    <div className="user-type-toggle">
                      <button
                        className={`toggle-btn toggle-buyer ${userType === "Buyer" ? "active" : ""
                          }`}
                        onClick={() => setUserType("Buyer")}
                      >
                        Buyer
                      </button>
                      <button
                        className={`toggle-btn toggle-gp ${userType === "Global Partner" ? "active" : ""
                          }`}
                        onClick={() => setUserType("Global Partner")}
                      >
                        Global Partner
                      </button>
                    </div>
                  </div>
                )}
              </div>
            <div
              className="mb-3"
              style={{
                display: "flex",
                justifyContent: "start",
                alignItems: "start",
                width: "100%",
              }}
            >
              
              {/* Left side tabs */}
              <div className="main-tab" style={{ marginRight: "20px" }}>
                <div>
                  {tabs.map((tab) => (
                    <button
                      key={tab}
                      className={`buttonclass ${activeTab === tab ? "active" : "notactive"
                        }`}
                      onClick={() => handleTabChange(tab)}
                    >
                      {tab}
                    </button>
                  ))}
                </div>
              </div>
              {/* Right side filter tabs */}
              <div className="main-tab" style={{ marginRight: "20px" }}>
                <div>
                  {getFilterTabs().map((filter) => (
                    <button
                      key={filter}
                      className={`buttonclass ${filterType === filter ? "active" : "notactive"
                        }`}
                      onClick={() => setFilterType(filter)}
                    >
                      {filter}
                    </button>
                  ))}
                </div>
              </div>
              {/* User Type Toggle Switch (only for RFQs) */}

            </div>

            <div className="row">{renderTabContent()}</div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default AmtplTrade;
